// This file includes components used by our client facing UI.
// Please lazily load large components.

import { registerComponents } from "~/src/lib/reactComponentRegistry"

registerComponents({
  BudgetDisplayPill: import("~/src/components/BudgetDisplayPill"),
  ContactUs: import("~/src/components/ContactUs"),
  Controller: import("~/src/components/Controller/Controller"),
  CustomTraySolutionForm: import("~/src/components/Solutions/CustomTraySolutionForm"),
  CustomTraySolutionSelectorForm: import("~/src/components/Solutions/CustomTraySolutionSelectorForm"),
  DashboardDebugBox: import("~/src/components/DashboardDebugBox"),
  DashboardToaster: import("~/src/components/DashboardToaster"),
  DisplayTagList: import("~/src/components/DisplayTagList"),
  DropshipEditor: import("~/src/components/DropshipEditor/DropshipEditor"),
  ErrorPage: import("~/src/components/ErrorPage"),
  MessageContactForm: import("~/src/components/MessageContactForm"),
  NavbarProjectFolder: import("~/src/components/NavbarProjectFolder"),
  OrderRecipientDelivery: import("~/src/components/OrderRecipientDelivery"),
  OrderRecipientVerifyEmail: import("~/src/components/OrderRecipientVerifyEmail"),
  ProductDetail: import("~/src/components/ProductDetail"),
  ReactionStatistics: import("~/src/components/ReactionStatistics"),
  RequestCart: import("~/src/components/RequestCart"),
  SignIn: import("~/src/components/SignIn"),
  SolutionInstanceToggle: import("~/src/components/Solutions/SolutionInstanceToggle"),
  Spreadsheet: import("~/src/components/Spreadsheet/Spreadsheet"),
  StorefrontOrderHistoryControls: import("~/src/components/StorefrontOrderHistoryControls"),
  StoreKitInstanceForm: import("~/src/components/StoreKitInstances/StoreKitInstanceForm"),
  SelectionItemWarnings: import("~/src/components/SelectionItemWarnings"),
  StripeFieldSet: import("~/src/components/StripeFieldSet"),
  TeamForm: import("~/src/components/Teams/TeamForm"),
  TeamsTable: import("~/src/components/Teams/TeamsTable"),
  ThankYouNoteConfirmation: import("~/src/components/ThankYouNoteConfirmation"),
  ThankYouNoteLanding: import("~/src/components/ThankYouNoteLanding"),
  ThankYouNoteMessageCarousel: import("~/src/components/ThankYouNoteMessageCarousel"),
  ThankYouNotesIndex: import("~/src/components/ThankYouNotesIndex"),
})
